module.exports = __webpack_public_path__ + "60aef0dd779c43857fdf55bab8f2c5f5.svg";